"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.find");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _elementUi = require("element-ui");

var _loading = require("@/mixins/loading/loading");

var _lastMileV = require("@/mixins/last-mile-v2/last-mile-v2");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LMDPlanSearchComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LMDPlanSearchComponent, _Mixins);

  var _super = _createSuper(LMDPlanSearchComponent);

  function LMDPlanSearchComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, LMDPlanSearchComponent);
    _this = _super.apply(this, arguments);
    _this.searchFilter = 'planId';
    _this.searchText = '';
    return _this;
  }

  (0, _createClass2.default)(LMDPlanSearchComponent, [{
    key: "searchTruck",
    value: function searchTruck() {
      var _this2 = this;

      var searchQuery = this.searchText.trim().toLowerCase();
      var selectedTrucks = this.$plan.trucks.filter(function (truck) {
        return truck[_this2.searchFilter].find(function (item) {
          return item.toString().trim().toLowerCase().includes(searchQuery);
        });
      });

      if (selectedTrucks.length > 1) {
        var plateNumbers = selectedTrucks.map(function (t) {
          return t.plateNumber;
        });
        var errMsg = {
          title: this.$t('planning.messages.hasMultipleTruck') + ': ' + plateNumbers.join(', '),
          duration: 10000
        };

        _elementUi.Notification.error(errMsg);

        this.$emit('onSearchValueIsFound', null);
      } else if (selectedTrucks.length === 1) {
        this.$selectedTruck = selectedTrucks[0].truckId;
        var selectedPlanId = selectedTrucks[0].routes.find(function (route) {
          return route[_this2.searchFilter].toString().trim().toLowerCase().includes(searchQuery);
        });

        if (!this.helper.isUndefined(selectedPlanId)) {
          this.$emit('onSearchValueIsFound', selectedPlanId['planId']);
        }
      } else {
        this.$emit('onSearchValueIsFound', null);
      }
    }
  }]);
  return LMDPlanSearchComponent;
}((0, _vuePropertyDecorator.Mixins)(_loading.LoadingMixin, _lastMileV.LastMileDeliveryMixin));

LMDPlanSearchComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LMDPlanSearchComponent',
  components: {
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-input': _elementUi.Input,
    'el-button': _elementUi.Button
  }
})], LMDPlanSearchComponent);
var _default = LMDPlanSearchComponent;
exports.default = _default;